import React from "react"
import { Col } from "react-bootstrap"
import { Helmet } from "react-helmet-async"

//Import Images
import logoLight from "../../../assets/images/logo-light.png"
interface LoadingProps {
  message?: string
}
const Loading = ({ message }: LoadingProps) => {
  return (
    <React.Fragment>
      <Helmet>
        <title>Loading | Market Manager Platform</title>
      </Helmet>
      <div className="loading-bg d-flex align-items-center pb-0 vh-100">
        <div className="content-center w-100">
          <div className="container">
            <div className="row justify-content-center">
              <Col xl={6}>
                <div className="row align-items-center">
                  <div className="col-9 col-sm-9 col-md-6 col-lg-6 mx-auto">
                    <div className="row align-items-center">
                      <img
                        src={logoLight}
                        alt=""
                        className="img-fluid mx-auto d-block"
                      />
                    </div>

                    <div className="row align-items-center mt-3">
                      <div className="col-1 col-sm-1 col-md-2 col-lg-2 ms-auto">
                        <div
                          role="status"
                          className="spinner-border text-light"
                        >
                          <span className="sr-only">{`Loading ${
                            message || ""
                          }...`}</span>
                        </div>
                      </div>
                      <div className="col-2 col-sm-2 col-md-2 col-lg-3 ms-1 me-auto">
                        <h5 className="text-light">{`Loading ${
                          message || ""
                        }...`}</h5>
                      </div>
                    </div>
                  </div>
                </div>
              </Col>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  )
}

export default Loading
